import { ManagedEnrollmentTrainingListResponse, ManageEnrollOperation, UserInfoDtoPaginatedList } from "generated/CoreApi_v1";

export const OPERATION_PAGE_SIZE = 15;

export type EnrollmentEditActions = "none" | "confirm";

export type TrainingSelected = ManagedEnrollmentTrainingListResponse & { totalSelected: number;  };

export type EditEnrollmentStepProps = {
    canSave: boolean;
    setCanSave: (value: boolean) => void;
    goNextStep: () => void;
    goFirstStep: () => void;
    action: EnrollmentEditActions;
};

export type EnrollmentNavigationSource = {
    step: number;
};

export type EnrollmentNavigation = {
    to?: EnrollmentNavigationSource;
};

export type EnrollmentOperation = {
    value: ManageEnrollOperation;
    text: string;
    disabled: boolean;
};

export type EnrollmentOperationContextType = {
    loadingSelected: boolean;
    setLoadingSelected: React.Dispatch<React.SetStateAction<boolean>>;
    loadingUsers: boolean;
    setLoadingUsers: React.Dispatch<React.SetStateAction<boolean>>;
    posting: boolean;
    setPosting: React.Dispatch<React.SetStateAction<boolean>>;
    selectedUsers?: UserInfoDtoPaginatedList;
    setSelectedUsers: React.Dispatch<React.SetStateAction<UserInfoDtoPaginatedList | undefined>>;
};
